var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Layout from '@/container/Layout';
import { useHotlineClientTermsAgree } from '@/feature/hotline/client/hook/useHotlineClientTermsAgree';
import { useHotlineClientListFetch } from '@/feature/hotline/client/mypage/hook/useHotlineClientListFetch';
import { canUseHotlineClientUser } from '@/feature/hotline/client/util/canUseHotlineUser';
import { MypageClientHotlineView } from '@/feature/mypage/hotline/page/MypageClientHotlineView';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
/**
 * クライアントマイページ ホットラインタブ表示（ロジック部分のみ）
 */
export const MypageClientHotlinePage = () => {
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { rfp_unread_count: rfpUnreadCount } = useTypeSelector((state) => state.clientRfpCount);
    const profile = useTypeSelector((state) => state.profile);
    const { needsAgreement, onSubmit: onSubmitTermsModal } = useHotlineClientTermsAgree();
    /** ホットライン利用可能なユーザーか */
    const canUseHotline = useMemo(() => canUseHotlineClientUser(profile), [profile]);
    const { fetchHotlineList, hotlineList, isLoading } = useHotlineClientListFetch({
        dispatch,
        unmountRef,
    });
    // マウントごとにデータ取得
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            // ホットライン利用不可の場合はデータを取得しない
            if (!canUseHotline)
                return;
            yield fetchHotlineList();
        }))();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(MypageClientHotlineView, { canUseHotline: canUseHotline, isLoading: isLoading, list: hotlineList !== null && hotlineList !== void 0 ? hotlineList : null, onSubmitTermsModal: onSubmitTermsModal, rfpUnreadCount: rfpUnreadCount, showTermsModal: needsAgreement }) })));
};
